<!-- 雷达与指标数据 -->
<script setup>
import { inject, nextTick, onMounted, ref, defineProps, toRefs, watch } from 'vue';
import { getDashboardIndex_radar_map } from "@/service/apiList/dashboard"
import { useRoute } from 'vue-router';
import { getLangValue, getNewline } from "@/utils/common"; //获取后端语言
import { drawRadar } from "@/utils/chart.js"
import { sankey_v3 } from "@/service"
import { sankey2Chart, sankey1Chart } from "@/utils/chart.js"
const route = useRoute();
const radarData = ref({}); // 雷达图数据
const activeName = ref(''); // 标签栏
const activeMenu = inject('activeMenu')
const productInfo = inject('productInfo')
const sankeyPic = ref('') // 桑基图的缩略图
const loading = ref(false) // loading
const current_ragar_data = ref([]) // 用来显示
const chartTitle = ref('') // 雷达图标题
const currentTab = ref(0) // 当前tab
const disabledLoading = ref(false) //如果在加载就不需要
const sankey_v3_data = ref({}) // 存储产地-组成结构数据
const props = defineProps({
    activekey: {
        type: Number, //唯一的key
        required: true,
    },
    category_id: { // 后台需要的id
        type: Number,
        required: true,
    },
    category_key: { // 中英文key
        type: String,
        required: true,
    },
})
const { activekey, category_id, category_key } = toRefs(props)
const getRadarData = async () => {
    // 获取雷达图数据
    let params = {
        category_id: category_id.value, // 质量...
        id: route.params.id,
    }
    // 判断是否公开产品
    if(route.query.is_public==1) {
        params.is_public = 1
    }
    const resp = await getDashboardIndex_radar_map(params)
    if (resp.code == 0) {
        // 排序
        radarData.value = resp.payload
        radarData.value.radar_map?.sort((a, b) => {
            // 将 name 为 "综合" 的对象排到最前面
            if (a.name === "综合" && b.name !== "综合") return -1;
            if (a.name !== "综合" && b.name === "综合") return 1;
            return 0; // 其他元素保持原始顺序
        });
        if (radarData.value.radar_map?.length) {
            activeName.value = radarData.value.radar_map[0].name; // 默认选中第一个指标
        }
        // 显示雷达图
        nextTick(() => {
            makeCharts();
        })
        // console.log(radarData.value);
    }
}

const serChartSeriesValue = () => {
    // 获取数据
    let seriesObj = [
        {
            type: 'radar',
            tooltip: {
                trigger: 'item',
            },
            radarIndex: 0,
            // areaStyle: {},
            data: []
        },
    ]
    let legendData = [];
    let avgValueList = [];
    let data = {}
    if (activeName.value == '综合') {
        // 第一级的数据
        data = [...radarData.value.radar_map];
    } else {
        data = radarData.value.radar_map.find(item => item.name == activeName.value)?.children;
        if (data) {
            data.sort((a, b) => {
                // 将 name 为 "综合" 的对象排到最前面
                if (a.name === "综合" && b.name !== "综合") return -1;
                if (a.name !== "综合" && b.name === "综合") return 1;
                return 0; // 其他元素保持原始顺序
            });
        }
    }
    current_ragar_data.value = data;
    // console.log(current_ragar_data.value)
    let children_value_lsit = data ? data.map(item1 => item1.value) : []
    seriesObj[0].data.push({
        name: 11,
        value: children_value_lsit,
        // color: chartData.value[item].color,
        // 线条颜色
        lineStyle: {
            color: '#5470c6'
        },
        // 图形颜色  影响legend
        itemStyle: {
            color: '#5470c6'
        },
    })

    if (avgValueList.length == 0) {
        avgValueList = data ? data.map(item1 => item1.avg_value) : []
        seriesObj[0].data.push({
            name: getLangValue('dashboard.avg_value'),
            value: avgValueList,
            lineStyle: {
                color: '#999999',
            },
            itemStyle: {
                color: '#999999'
            },
        })
        legendData.push(getLangValue('dashboard.avg_value'));
    }
    return { seriesObj, data };
}
const makeCharts = () => {
    // get dom
    let dom;
    if (activeName.value == '综合') {
        dom = document.getElementById(`chart_${activekey.value}_0`);
    } else {
        dom = document.getElementById(`chart_${activekey.value}_${radarData.value.radar_map.findIndex(item => item.name == activeName.value)}`)
    }
    // getdata
    let { seriesObj: data, data: data1 } = serChartSeriesValue();

    // make charts
    let indicatorList = data1 ? data1.map(item => {
        return {
            name: route.query.lang == 'en' ? getNewline(item.name_en, 10) : getNewline(item.name, 10),
            name1: route.query.lang == 'en' ? item.name_en : item.name,
            max: 1,
        }
    }) : []
    if (indicatorList.length == 0) {
        return
    }
    let option = {
        // color: colors,
        tooltip: {
            trigger: 'axis',
            confine: true,
            formatter: function (params) {
                let str = ` <div style='color: ${params.color};font-weight: bold'>${params.name}</div>`;
                for (const item in params.value) {
                    str += `
                       
                        <div>
                        <div style='min-width:100px; text-align:left; display:inline-block'>
                            ${indicatorList[item].name1}
                        </div>
                            :
                         <div style='min-width:100px; text-align:left; display:inline-block'>${params.value[item] == null ? '-' : params.value[item]}</div>
                    </div>`
                }
                return str
            }
        },
        // legend: {
        //     data: legendData,
        //     bottom: 0,
        // },
        radar: {
            indicator: indicatorList,
            radius: indicatorList.length == 2 ? 60 : 70, // 2个角必须小一点否则就撑满了
            // 同时需要调整一下显示位置
            center: indicatorList.length == 2 ? ['50%', '45%'] : indicatorList.length == 3 ? ['50%', '55%'] : ['50%', '50%'],
            // 设置角标颜色和样式
            axisName: {
                color: '#000', // 设置角标颜色
                fontSize: 13, // 字体大小
            },
            axisLabel: {
                show: true,
                formatter: function (value, index) {
                    // 只在最后一个角显示最大值
                    if (index === 5) {
                        return value;
                    } else {
                        return '';
                    }
                },
                margin: 10,
            }
        },

        // [
        //     {
        //         indicator: indicatorList,
        //         radius: 100
        //     }
        // ],
        series: data,
    };
    nextTick(() => {
        // console.log(dom);
        dom && drawRadar(dom, option)
    })
}

const getchartData = async () => {
    // 获取图表数据
    let params = {
        table_name: productInfo.value.organization?.table_name,
        database_id: productInfo.value.id,
        category_id: category_id.value,
        type: 0,
    }
    loading.value = true;
    const reps = await sankey_v3(params)
    loading.value = false;
    if (reps.code == 1) {
        // showMessage('danger', reps.message)
        return
    }
    if (reps.payload.nodes.length && reps.payload.links.length) {
        let obj = JSON.parse(JSON.stringify(reps.payload))
        const { nodes: nodes1, links: links1 } = obj;
        sankey_v3_data.value = {
            nodes: nodes1,
            links: links1
        }
        nextTick(() => {
            makeCharts1(reps.payload,)
        })
    } else {
        document.getElementById('snakey_chart1').innerHTML = getLangValue('base', 'no_data')
    }
}
const makeCharts1 = (data,) => {
    // 开始画桑基图
    let options = {
        chartDom: document.getElementById('snakey_chart1'),
        data: data,
        nodeDataList: data.nodes,
        title: chartTitle.value,
    };
    let myChart = null;
    // 如果是追溯 用的sankey2Chart 其他的用sankey1Chart
    // 如果是追溯 需要判断tab
    if(props.category_id !=1) {
        myChart = sankey1Chart(options, false, 'normal', true, 'passport', 'value', props.category_id);
    }else{
        myChart = currentTab.value == 0 ? sankey2Chart(options, true, 'normal', 'place',) : sankey2Chart(options, true, 'normal', 'value',);
    }
    nextTick(() => {
        myChart.on("finished", () => {
            sankeyPic.value = myChart.getDataURL({
                type: "png",
                pixelRatio: 2,
                backgroundColor: "#ffffff"
            });
        });
    })

    // console.log(imgData);
}
const getNameByCategory = () => {
    // 根据分类获取内置的标题  追溯
    switch (props.category_id) {
        case 3:
            return getLangValue('dashboard.quality.quality_traceability_diagram')
        case 5:
            return getLangValue('dashboard.environment.quality_traceability_diagram')
        case 6:
            return getLangValue('dashboard.esg.quality_traceability_diagram')
        case 4:
            return getLangValue('dashboard.circularity.quality_traceability_diagram')
        case 2:
            return getLangValue('dashboard.comfort.quality_traceability_diagram')
        case 1:
            return getLangValue('dashboard.traceability.quality_traceability_diagram')
        default:
            return getLangValue('dashboard.quality.quality_traceability_diagram')
    }


}

const getSankeyTitle = () => {
    // 获取桑吉图标题
    switch (category_id.value) {
        case 3:
            return getLangValue('dashboard.quality.sankey_title')
        case 5:
            return getLangValue('dashboard.environment.sankey_title')
        case 6:
            return getLangValue('dashboard.esg.sankey_title')
        case 4:
            return getLangValue('dashboard.circularity.sankey_title')
        case 2:
            return getLangValue('dashboard.comfort.sankey_title')
        case 1:
            return currentTab.value ==0? getLangValue('dashboard.traceability.product_name_origin') :  getLangValue('dashboard.traceability.product_name_composition_ratio') 
        default:
            return getLangValue('dashboard.quality.sankey_title')
    }
}

onMounted(() => {
    // getRadarData();
    // console.log(category_key);

})

watch(activeMenu, (val) => {
    // 监听菜单切换
    if (val == activekey.value) {
        getRadarData();
        // 设置标题
        chartTitle.value = getSankeyTitle();
        getchartData();
    }
})

watch(activeName, () => {
    // 监听切换tab
    makeCharts();
})

watch(currentTab, () => {
    // 设置标题
    chartTitle.value = getSankeyTitle();
    if (sankey_v3_data.value.nodes) {
        makeCharts1(sankey_v3_data.value,)
    }
})

</script>
<template>
    <div class="radarInstandard" v-loading="loading">
        <div class="title-1 py-3">{{ getLangValue('dashboard', 'product_performance') }}</div>
        <!-- tab -->
        <el-tabs v-model="activeName" class="demo-tabs" v-if="radarData.radar_map?.length">
            <el-tab-pane :label="route.query.lang == 'en' ? item.name_en : item.name" :name="item.name"
                v-for="(item, k) in radarData.radar_map" :key="k">
                <!-- 描述 -->
                <div class="pb-3">
                    <div class="info my-1">{{ getLangValue('dashboard', `${category_key}.titleText6`) }}</div>
                    <div class="info my-1">{{ getLangValue('dashboard', `${category_key}.titleText7`) }}</div>
                </div>
                <!-- 图表 -->
                <div :id='`chart_${activekey}_${k}`' style="width: 100%; height: 300px;"></div>
                <div>
                    <div class="my-1 info" v-for="(aa, k) in current_ragar_data" :key="k">
                        {{ route.query.lang == 'en' ? aa.name_en : aa.name }} : {{ aa.value }}
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
        <Empty :flag="1" v-else class="my-1"></Empty>
        <div class="title-1 py-3" v-if="category_key == 'traceability'">
            <div class="d-flex justify-content-between align-items-center">
                {{ currentTab == 0 ? getLangValue('dashboard.traceability.origin_traceability_map') :
                    getLangValue('dashboard.traceability.composition_traceability_diagram') }}
                <el-radio-group v-model="currentTab" size="small" :disabled="disabledLoading">
                    <el-radio-button :label="getLangValue('dashboard.traceability.origin_traceability')" value="0" />
                    <el-radio-button :label="getLangValue('attribute.composition')" value="1" />
                </el-radio-group>
            </div>
        </div>
        <div class="title-1 py-3" v-else>{{ getNameByCategory() }}</div>
        <img :src="sankeyPic" v-if="sankeyPic">
        <Empty :flag="1" v-if="loading && !sankeyPic" class="my-1"></Empty>
        <div id="snakey_chart1" style="width: 1000px; height: 300px; display: none;"></div>
    </div>
</template>
<style scoped lang="scss">
.radarInstandard {
    .title-1 {
        color: #495057;
        font-size: 0.9rem;
        text-align: left;
        font-weight: bold;
        border-bottom: 1px solid #0000001A;
    }

    .info {
        color: #212529;
    }

    // tab颜色修改
    :deep(.el-tabs__item.is-active) {
        color: #0AB39C;
    }

    :deep(.el-tabs__active-bar) {
        background-color: #0AB39C;
    }
}
</style>